import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetOrderModel } from './get-order.state';

/** StateDetailsActions */
const ACTION_SET = '[GetOrder] set';
const ACTION_UPDATE = '[GetOrder] update';
const ACTION_RESET = '[GetOrder] reset';
const ACTION_FAIL = '[GetOrder] fail';
const ACTION_CANCEL_REQUEST = '[GetOrder] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetOrder] set from api';
const ACTION_UPDATE_FROM_API = '[GetOrder] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetOrder = createAction(ACTION_SET, props<WithRequestId<GetOrderModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetOrder = createAction(ACTION_UPDATE, props<WithRequestId<Partial<GetOrderModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetOrder = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetOrderRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetOrder = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetOrderFromApi = createAction(ACTION_SET_FROM_API, asyncProps<FromApiActionPayload<GetOrderModel>>());

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetOrderFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetOrderModel>>()
);
